import React from "react";
import "./App.css";
import Weather from "./Weather";
export default function App() {
  return <Weather defaultCity="London" />;
}
